/* tslint:disable */
import {
  App,
  Paastenant,
  Tenant,
  Entity
} from '../index';

declare var Object: any;
export interface ApptypeInterface {
  name: string;
  description: string;
  status: string;
  lastupdatedby?: string;
  createdby?: string;
  id?: any;
  paastenantId?: any;
  createdAt: Date;
  updatedAt: Date;
  app?: App[];
  paastenant?: Paastenant;
  tenants?: Tenant[];
  entities?: Entity[];
}

export class Apptype implements ApptypeInterface {
  name: string;
  description: string;
  status: string;
  lastupdatedby: string;
  createdby: string;
  id: any;
  paastenantId: any;
  createdAt: Date;
  updatedAt: Date;
  app: App[];
  paastenant: Paastenant;
  tenants: Tenant[];
  entities: Entity[];
  constructor(data?: ApptypeInterface) {
    Object.assign(this, data);
  }
  /**
   * The name of the model represented by this $resource,
   * i.e. `Apptype`.
   */
  public static getModelName() {
    return "Apptype";
  }
  /**
  * @method factory
  * @author Jonathan Casarrubias
  * @license MIT
  * This method creates an instance of Apptype for dynamic purposes.
  **/
  public static factory(data: ApptypeInterface): Apptype{
    return new Apptype(data);
  }  
  /**
  * @method getModelDefinition
  * @author Julien Ledun
  * @license MIT
  * This method returns an object that represents some of the model
  * definitions.
  **/
  public static getModelDefinition() {
    return {
      name: 'Apptype',
      plural: 'apptypes',
      properties: {
        name: {
          name: 'name',
          type: 'string'
        },
        description: {
          name: 'description',
          type: 'string'
        },
        status: {
          name: 'status',
          type: 'string'
        },
        lastupdatedby: {
          name: 'lastupdatedby',
          type: 'string',
          default: 'system'
        },
        createdby: {
          name: 'createdby',
          type: 'string',
          default: 'system'
        },
        id: {
          name: 'id',
          type: 'any'
        },
        paastenantId: {
          name: 'paastenantId',
          type: 'any'
        },
        createdAt: {
          name: 'createdAt',
          type: 'Date'
        },
        updatedAt: {
          name: 'updatedAt',
          type: 'Date'
        },
      },
      relations: {
        app: {
          name: 'app',
          type: 'App[]',
          model: 'App'
        },
        paastenant: {
          name: 'paastenant',
          type: 'Paastenant',
          model: 'Paastenant'
        },
        tenants: {
          name: 'tenants',
          type: 'Tenant[]',
          model: 'Tenant'
        },
        entities: {
          name: 'entities',
          type: 'Entity[]',
          model: 'Entity'
        },
      }
    }
  }
}



// WEBPACK FOOTER //
// ./src/app/shared/sdk/models/Apptype.ts